<template>
  <v-row justify="center" no-gutters v-if="_order">
    <v-col xl="8" lg="9" md="10" sm="12" cols="12">
      <v-row justify="center" class="pt-xl-4 pt-lg-4 pt-md-4 pb-xl-12 pb-lg-12 pb-md-8 pb-sm-4 pb-4" no-gutters>
        <v-col class="pr-xl-3 pr-lg-3 pr-md-3" cols="12">
          <v-card outlined>
            <v-toolbar class="mt-xl-4 mt-lg-4 mt-md-4 mt-sm-4" flat dense>
              <v-toolbar-title class="section-title px-2">{{ getDeliveryTitle }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="text-left px-0 pt-2">
              <v-timeline class="mr-4" dense clipped>
                <v-timeline-item
                  :color="shipmentHasFinalStatus ? 'success' : 'blue'"
                  small v-for="delivery in getDeliveryByStatus"
                  :key="'delivery_'+delivery.status">
                  <v-row justify="space-between">
                    <v-col cols="12">
                      <div :class="getTitleClass(delivery.status)" class="status-title">{{ getDeliveryStatusName(delivery.status) }}</div>
                      <div v-for="(detail, index) in delivery.details" :key="'delivery_detail_'+index">
                        {{ dateFormat(detail.creation_date, 'D [de] MMM hh:mm a') }}, {{ getDeliveryStatusDescription(detail.description, delivery.status) }}
                      </div>
                    </v-col>
                  </v-row>
                </v-timeline-item>
              </v-timeline>
            </v-card-text>
            <v-divider class="my-2 mb-2"></v-divider>
            <v-card-text class="pt-0 pb-0">
              <v-list-item class="text-left mx-2" flat>
                <v-list-item-avatar>
                  <v-icon class="blue" dark>
                    mdi-truck
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content two-line>
                  <v-list-item-title class="subtitle-2">
                    <span class="font-weight-bold">Tipo de envio</span>
                  </v-list-item-title>
                  <v-list-item-title class="subtitle-2">{{ getDeliveryTypeDescription(_order.delivery.delivery_type) }}</v-list-item-title>
                  <v-list-item-subtitle class="location-description">
                    <div :class="'status-description-' + getDeliveryLastRecord.status" v-if="shipmentHasFinalStatus">
                      {{ getDeliveryStatusTitle(getDeliveryLastRecord.status) }} el {{ dateFormat(getDeliveryLastRecord.creation_date, 'D MMM YYYY') }}
                    </div>
                    <div v-else>
                      <span v-if="toBePickedUpInStore">
                        Retira a partir del {{ dateFormat(addDaysToCurrentDate(_order.delivery.delivery_days), 'D MMM YYYY') }}
                      </span>
                      <span v-else>
                        Llega el {{ dateFormat(addDaysToCurrentDate(_order.delivery.delivery_days), 'D MMM YYYY') }}
                      </span>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
            <v-divider class="my-2 mb-2"></v-divider>
            <v-card-text class="pt-0">
              <v-list-item class="text-left mx-2" flat>
                <v-list-item-avatar>
                  <v-icon class="blue" dark>
                    mdi-map-marker
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content three-line>
                  <v-list-item-title class="subtitle-2">
                    <span class="font-weight-bold">Recibe:</span>
                    <span>&nbsp;{{ _order.user.first_name }} {{ _order.user.last_name }}</span>
                  </v-list-item-title>
                  <v-list-item-title class="subtitle-2">{{ _order.address.address }}</v-list-item-title>
                  <v-list-item-subtitle class="subtitle-2"  v-if="_order.address.additional_address">
                    {{ _order.address.additional_address }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="subtitle-2">
                    {{ _order.address.neighborhood }}, {{ _order.address.city.name }}, {{ _order.address.region.name }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  <div v-else>
    <shipment-loader></shipment-loader>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import ShipmentLoader from '@/loaders/ShipmentLoader'
import { getDeliveryStatusName, getDeliveryStatusDescription, getDeliveryStatusTitle, getDeliveryTypeDescription, DELIVERY_STATUS_PENDING, DELIVERY_STATUS_IN_PROGRESS, DELIVERY_STATUS_DELIVERED, DELIVERY_STATUS_RETURNED, COLLECT_IN_STORE_DELIVERY_TYPE } from '@/shared/delivery'
import { addDaysToCurrentDate } from '@/shared/date'
import { dateFormat } from '@/shared/format'

export default {
  components: {
    ShipmentLoader
  },
  computed: {
    ...mapState('order', ['_order']),
    ...mapGetters('order', ['getDeliveryTitle', 'getDeliveryByStatus', 'getDeliveryLastStatus', 'getDeliveryLastRecord']),
    shipmentHasFinalStatus () {
      const record = this.getDeliveryLastRecord

      return record && (record.status === DELIVERY_STATUS_DELIVERED || record.status === DELIVERY_STATUS_RETURNED)
    },
    toBePickedUpInStore () {
      return this._order.delivery.delivery_type === COLLECT_IN_STORE_DELIVERY_TYPE
    }
  },
  data () {
    return {
      getDeliveryStatusName,
      getDeliveryStatusDescription,
      getDeliveryStatusTitle,
      addDaysToCurrentDate,
      getDeliveryTypeDescription,
      dateFormat
    }
  },
  methods: {
    ...mapActions('order', ['getOrder']),
    getTitleClass (status) {
      if (status === DELIVERY_STATUS_PENDING || status === DELIVERY_STATUS_IN_PROGRESS) {
        return this.getDeliveryLastStatus === status ? 'current-status-title' : 'status-title'
      }

      return status === DELIVERY_STATUS_DELIVERED ? 'status-title-delivered' : 'status-title-returned'
    }
  },
  mounted () {
    this.getOrder(this.$route.params.id)
  }
}
</script>

<style lang="scss" scoped>
  @import '~vuetify/src/styles/settings/_variables';

  .status-title {
    color: rgba(0, 0, 0, 0.25);
    font-size: 16px;
  }
  .current-status-title {
    color: #000000;
    font-size: 16px;
  }
  .status-title-delivered {
    color: #388E3C;
    font-size: 16px;
    font-weight: 600;
  }
  .status-title-returned {
    color: #F57C00;
    font-size: 16px;
    font-weight: 600;
  }
  .status-description-delivered {
    color: #388E3C;
    font-weight: 600;
  }
  .status-description-returned {
    color: #F57C00;
    font-weight: 600;
  }
</style>
